import * as React from 'react';
import { TextField } from '@mui/material';
import { Button, Dialog, ThemeTextSize } from '.';
import AppService, { textsize } from '../services/app.service';


interface Props {
  id?: string;
  name: string;
  label?: string;
  placeHolder?: string;
  value: any;
  caption: string;
  size?: textsize;
  box?: boolean;
  color?: any;
  readOnly?: boolean;
  disableAutoClose?: boolean;
  disableMargin?: boolean;
  clearValue?: (data: any) => void;
  onChange?: (fieldName: string, value?: string) => void;
  error?: string;
  children?: React.ReactNode;
}

export const InputPicklist: React.FunctionComponent<Props> = (props) => {
  const [open, setOpen] = React.useState(false);
  const isMobile = AppService.isMobile();

  const fontSize = (size?: textsize) => {
    return ThemeTextSize(size || props.size).fontSize;
  }
  
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => { 
    props.onChange?.(props.name, e?.target.value);
  }
  
  React.useEffect(() => {
    if (!props.disableAutoClose) setOpen(false)
  }, [props])

  return (
    <TextField
      id={props.id || props.name}
      name={props.name}
      label={props.label}
      type='input'
      value={props.caption || ''}
      placeholder={props.placeHolder}
      InputProps={{
        readOnly: true,
        sx: {fontSize: fontSize(), bgcolor: props.color, borderRadius: 3, marginTop: props.box? 1.5 : 0},
        endAdornment: !props.readOnly &&
          <>
          {props.clearValue && (typeof props.value === 'object'? props.value?.length > 0 : props.value) &&
            <Button startIcon='clear' size='extrasmall' disablePadding onClick={() => props.clearValue?.(null)} />
          }
          <Button startIcon='margin' size={isMobile? 'medium' : 'small'} disablePadding onClick={() => setOpen(true)} />
          <Dialog open={open} onClose={() => setOpen(false)}> {props.children} </Dialog>
          </>
        ,
      }}
      InputLabelProps={{
        shrink: true,
        sx: {fontSize: fontSize() + (isMobile? 0 : 2), left: props.box? -7 : 0}
      }}
      FormHelperTextProps={{
        sx: {fontSize: fontSize(isMobile? 'medium' : 'small')}
      }}
      sx = {props.box? {'& legend': {width: 0}} : undefined}
      margin={props.disableMargin? 'none' : 'normal'}
      variant={props.box? undefined : 'standard'}
      fullWidth
      helperText={props.error}
      error= {props.error? true: false}
      onChange={onChange}
    />
  )
}